<template>
  <div class="average-score">
    <table v-if="classAverageScoreList.length" border="1"
      style="width: 98%; border-collapse: collapse; margin: 10px auto;">
      <thead>
        <tr style="background-color: #0066cc; color: #fff;">
          <th :rowspan="2">班级</th>
          <th
            v-for="(course, index) in classAverageScoreList[classAverageScoreList.length - 1].courseStandardDeviationList"
            :key="index" :colspan="3">{{
              course.courseName }}</th>
        </tr>
        <tr style="background-color: #0066cc; color: #fff;">
          <template
            v-for="(course, index) in classAverageScoreList[classAverageScoreList.length - 1].courseStandardDeviationList">
            <th :key="index + 'avg'">平均分</th>
            <th :key="index + 'rank'">排名</th>
            <th :key="index + 'diff'">级差值</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(classItem, index) in classAverageScoreList" :key="index">
          <td>{{ classItem.className }}</td>
          <template
            v-for="(course, cIndex) in classAverageScoreList[classAverageScoreList.length - 1].courseStandardDeviationList">
            <td :key="cIndex + 'avg'">{{ getCourseInfo(classItem, course.courseName, 'score') }}</td>
            <td :key="cIndex + 'rank'">{{ getCourseInfo(classItem, course.courseName, 'rank') }}</td>
            <td :key="cIndex + 'diff'">{{ getCourseInfo(classItem, course.courseName, 'gradeDifference') }}</td>
          </template>
        </tr>
      </tbody>
    </table>
    <div v-else><el-empty description="暂无数据"></el-empty></div>
  </div>
</template>

<script>
export default {
  props: ['classAverageScoreList'],
  data() {
    return {

    }
  },
  methods: {
    getCourseInfo(classItem, courseName, infoType) {
      // 尝试找到与提供的 courseName 匹配的课程信息
      let courseInfo = classItem.courseStandardDeviationList.find(course =>
        course.courseName === courseName
      );

      // 如果没有找到匹配的 courseName，检查是否有 className 为 "班级平均分" 且 courseName 为 null 的项
      if (!courseInfo) {
        courseInfo = classItem.courseStandardDeviationList.find(course =>
          course.courseName === null && course.className === '班级平均分'
        );
      }

      // 如果找到了对应的课程信息，则返回所需的信息类型；否则返回 '-'
      if (courseInfo && courseInfo[infoType] != -1) {
        return courseInfo[infoType];
      } else {
        return '-'; // 如果找不到对应的课程信息，则返回'-'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './averageScore.scss';
</style>